import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import { ISupport } from '@/types/types/forms/support/support.interface';

const makeSupportService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        requestSupport: async (data: Partial<ISupport>): Promise<void> => {
            await fetcher.post('', JSON.stringify(data));
        },
    };
};

export const supportService = makeSupportService(config.api.url.support);
